import { Badge } from '@/components/ui/badge';
import type { FundTransactionStatus } from '@/types/fund-transactions';

const STATUS_VARIANTS: Record<
  FundTransactionStatus,
  'secondary' | 'default' | 'destructive' | 'outline'
> = {
  DRAFT: 'secondary',
  ISSUED: 'outline',
  APPROVED: 'default',
  POSTED: 'default',
  REVERSED: 'destructive',
};

const STATUS_LABELS: Record<FundTransactionStatus, string> = {
  DRAFT: 'Draft',
  ISSUED: 'Issued',
  APPROVED: 'Approved',
  POSTED: 'Posted',
  REVERSED: 'Reversed',
};

/**
 * A fund transaction's workflow state, styled the same wherever it is listed.
 *
 * Shared so that the currency screen and the all-transactions table cannot
 * drift into calling the same state by two different names.
 */
export function FundTransactionStatusBadge({
  status,
}: {
  status: FundTransactionStatus;
}) {
  return (
    <Badge variant={STATUS_VARIANTS[status]}>
      {STATUS_LABELS[status] ?? status}
    </Badge>
  );
}
